import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import {
  Send as SendIcon,
  ArrowBack as ArrowBackIcon,
  WhatsApp as WhatsAppIcon,
  Badge as BadgeIcon,
  Poll as PollIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../contexto/store';
import { obtenerTodasLasEncuestas, enviarEncuestaWhatsApp } from '../../actions/EncuestaAction';
import { RegistrarAccion } from '../../actions/AuditoriaAction';

const EnviarEncuestaWhatsApp = (props) => {
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [encuestas, setEncuestas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [formData, setFormData] = useState({
    encuestaId: '',
    poolId: '',
  });

  useEffect(() => {
    cargarEncuestas();
  }, []);

  useEffect(() => {
    console.log('FormData actualizado:', formData);
  }, [formData]);

  const cargarEncuestas = () => {
    obtenerTodasLasEncuestas()
      .then((response) => {
        console.log('Encuestas recibidas:', response.data);
        console.log('Primera encuesta:', response.data && response.data.length > 0 ? response.data[0] : 'sin datos');
        if (response.status === 200) {
          setEncuestas(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error al cargar encuestas:', error);
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Error al cargar las encuestas disponibles',
          },
        });
        setLoading(false);
      });
  };

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    console.log('Campo modificado:', name, 'Valor:', value, 'Tipo:', typeof value);
    console.log('Estado actual formData:', formData);
    console.log('Event target completo:', e.target);
    setFormData((anterior) => {
      const nuevoEstado = {
        ...anterior,
        [name]: value,
      };
      console.log('Nuevo estado formData:', nuevoEstado);
      return nuevoEstado;
    });
  };

  const handleEncuestaChange = (event) => {
    const selectedValue = event.target.value;
    console.log('=== handleEncuestaChange ===');
    console.log('event.target.value:', selectedValue, 'tipo:', typeof selectedValue);
    
    setFormData((anterior) => {
      const nuevoEstado = {
        ...anterior,
        encuestaId: selectedValue,
      };
      console.log('FormData actualizado a:', nuevoEstado);
      return nuevoEstado;
    });
  };

  const enviarEncuesta = () => {
    console.log('Intentando enviar con formData:', formData);
    console.log('encuestaId RAW:', formData.encuestaId, 'tipo:', typeof formData.encuestaId);
    console.log('poolId:', formData.poolId, 'tipo:', typeof formData.poolId);
    
    if (!formData.encuestaId || !formData.poolId) {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Por favor complete todos los campos obligatorios',
        },
      });
      return;
    }

    setEnviando(true);
    
    const datosEnvio = {
      encuestaId: formData.encuestaId,
      poolId: formData.poolId.toString(),
    };
    
    console.log('Datos a enviar al backend:', datosEnvio);
    console.log('poolId valor:', formData.poolId, 'tipo:', typeof formData.poolId);
    console.log('JSON.stringify:', JSON.stringify(datosEnvio));

    enviarEncuestaWhatsApp(datosEnvio)
      .then((response) => {
        console.log('Respuesta del servidor:', response);
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Encuesta enviada exitosamente por WhatsApp',
            },
          });
          setFormData({
            encuestaId: '',
            poolId: '',
          });
          let objetoAudi = {
            usuario: sesionUsuario.usuario.nombrecompleto,
            accion: 'Envío WhatsApp',
            panel: 'Gestion de Encuestas',
            tabla: 'ENCUESTAS',
            filaafectada: `Encuesta ID: ${formData.encuestaId} - Pool: ${formData.poolId}`,
            UsuarioId: sesionUsuario.usuario.id,
          };
          RegistrarAccion(objetoAudi);
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Error al enviar la encuesta por WhatsApp',
            },
          });
        }
        setEnviando(false);
      })
      .catch((error) => {
        console.error('Error completo al enviar encuesta:', error);
        console.error('Error.response:', error.response);
        console.error('Error.response.data:', error.response ? error.response.data : 'no data');
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: error.response && error.response.data ? 
              `Error: ${JSON.stringify(error.response.data)}` : 
              'Error al enviar la encuesta por WhatsApp',
          },
        });
        setEnviando(false);
      });
  };

  const volver = () => {
    props.history.goBack();
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <WhatsAppIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Enviar Encuesta por WhatsApp
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Selecciona una encuesta y envíala a través de WhatsApp
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Formulario de envío */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Información de Envío
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="encuesta-label">Seleccionar Encuesta *</InputLabel>
              <Select
                labelId="encuesta-label"
                id="encuesta-select"
                value={formData.encuestaId || ''}
                onChange={handleEncuestaChange}
                label="Seleccionar Encuesta *"
                sx={{
                  '& .MuiSelect-select': {
                    py: 2,
                    fontSize: '1.1rem',
                  },
                }}
              >
                <MenuItem value="">
                  <em>Seleccione una encuesta</em>
                </MenuItem>
                {encuestas && encuestas.length > 0 ? (
                  encuestas.map((encuesta, index) => {
                    console.log(`Renderizando encuesta ${index}:`, encuesta);
                    return (
                      <MenuItem 
                        key={`encuesta-${encuesta.encuestaId}`}
                        value={encuesta.encuestaId}
                        sx={{ py: 1.5, fontSize: '1rem' }}
                      >
                        {encuesta.titulo || encuesta.nombre || `Encuesta ${encuesta.numEncuesta}`}
                      </MenuItem>
                    );
                  })
                ) : (
                  <MenuItem disabled>No hay encuestas disponibles</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              name="poolId"
              value={formData.poolId}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Pool ID *"
              placeholder="Ingrese el Pool ID"
              required
              sx={{
                '& .MuiInputBase-input': {
                  py: 2,
                  fontSize: '1.1rem',
                },
              }}
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Botones de acción */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
        }}
      >
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={volver}
          disabled={enviando}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-2px)',
              boxShadow: 2,
            },
            transition: 'all 0.2s ease',
          }}
        >
          Volver
        </Button>

        <Button
          variant="contained"
          size="large"
          startIcon={enviando ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          onClick={enviarEncuesta}
          disabled={enviando}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          {enviando ? 'Enviando...' : 'Enviar Encuesta'}
        </Button>
      </Box>
    </Container>
  );
};

export default EnviarEncuestaWhatsApp;
